(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemstones"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    var filterDrawerForm = document.querySelector(".filter-drawer");
    var filterDrawerPanel = document.querySelector(".filter-drawer__panel");
    var filterDrawerWash = document.querySelector(".filter-drawer__wash");

    function addClassesAndAttributes() {
      filterDrawerForm.classList.add("is-fixed", "active");
      setTimeout(setActiveOnFilterPanel, 200);
    }

    function setActiveOnFilterPanel(){
        filterDrawerPanel.classList.add("active");
    }

    function removeActiveFromFilterDrawer(){
      filterDrawerForm.classList.remove("is-fixed", "active");
      
    }

    function closeFilterDrawer() {
      filterDrawerPanel.classList.remove("active");
       setTimeout(removeActiveFromFilterDrawer, 200);
    }

    function clearFilters() {
      document.querySelectorAll("input[type='checkbox']").forEach(e => {
        e.removeAttribute('checked');
      });
    }

    var openButton = document.getElementById("openSymbolicFilterDrawer");
    var closeButton = document.querySelector(".filter-drawer__close");
    var clearFilterButton = document.querySelector('.filter-drawer__footer .filter-drawer__button-clear');

    openButton.addEventListener("click", addClassesAndAttributes);
    closeButton.addEventListener("click", closeFilterDrawer);
    filterDrawerWash.addEventListener("click", closeFilterDrawer);
    clearFilterButton.addEventListener("click", clearFilters)

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sortBy = urlParams.getAll('sort_by')
    document.querySelectorAll("input[type='checkbox']").forEach(e => {
      var filter = e.value;
      if(sortBy.includes(filter)) {
        e.setAttribute('checked', 'checked')
      }
    });
    
    if(sortBy[0] != undefined){
      clearFilterButton.style.display = "block";
      var items = document.querySelectorAll('[data-symbolic-filter]');
      items.forEach(item => {
        var data = item.querySelectorAll('[data-symbolics]');
        var symbolic_array = JSON.parse(data[0].dataset.symbolics);
        var removeItemFromDom = true;
        sortBy.forEach(queryParam => {
          symbolic_array.forEach(sym => {
            if(queryParam.replace(" ", "") == sym){
              removeItemFromDom = false;
            }
          })
        })
        if(removeItemFromDom){
          item.remove();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
